import React from 'react'
import Skeleton from '../Skeleton'

const TransactionsSkeleton = () => {
    return (
        <div className="p-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
                <div>
                    <Skeleton className="h-8 w-48 mb-2" />
                    <Skeleton className="h-4 w-64" />
                </div>

                <Skeleton className="h-10 w-28 rounded-lg" />
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="glass-card p-6">
                        <div className="flex items-center justify-between">
                            <div>
                                <Skeleton className="h-4 w-24 mb-2" />
                                <Skeleton className="h-8 w-16" />
                            </div>
                            <Skeleton className="h-10 w-10 rounded-full" />
                        </div>
                    </div>
                ))}
            </div>

            {/* Filters and Search */}
            <div className="glass-card p-4 mb-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                    <div className="flex items-center space-x-4">
                        <Skeleton className="h-6 w-16" />
                        <Skeleton className="h-10 w-32 rounded-lg" />
                    </div>
                    <Skeleton className="h-10 w-64 rounded-lg" />
                </div>
            </div>

            {/* Transactions List */}
            <div className="glass-card p-4">
                <div className="space-y-4">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="p-4 border border-white/5 rounded-lg bg-white/5">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                                <div className="flex items-center space-x-4 w-full">
                                    <Skeleton className="w-10 h-10 rounded-full flex-shrink-0" />
                                    <div className="flex-1 space-y-2 min-w-0">
                                        <div className="flex items-center space-x-2">
                                            <Skeleton className="h-5 w-32 sm:w-40" />
                                            <Skeleton className="h-5 w-5 rounded-full" />
                                        </div>
                                        <Skeleton className="h-4 w-full sm:w-64 max-w-[200px] sm:max-w-none" />
                                    </div>
                                </div>

                                <div className="flex flex-row sm:flex-col items-center sm:items-end justify-between sm:justify-center pl-14 sm:pl-0 w-full sm:w-auto mt-2 sm:mt-0">
                                    <Skeleton className="h-6 w-24 sm:ml-auto" />
                                    <Skeleton className="h-5 w-16 rounded-full sm:ml-auto" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TransactionsSkeleton
